import React from 'react';
import { useRouter } from 'next/router';

import {
	DeployProvider,
	ProjectProvider,
	TemplateProvider,
	useApp,
	useClient,
	useSearch,
	useSession,
	useStorage,
	useStore,
	useToast,
	useWorkspace,
	WorkspaceProfileProvider,
} from 'contexts';

export const PageContext = React.createContext(null);

const PageProvider = ({ ssr, children }) => {
	const app = useApp();
	const client = useClient();
	const workspace = useWorkspace();
	const router = useRouter();
	const search = useSearch();
	const session = useSession();
	const storage = useStorage();
	const store = useStore();
	const toast = useToast();
	const contexts = { ssr, app, client, workspace, router, search, session, store, storage, toast, children };

	// Render
	if (router.pathname.includes('/deploys/[deployId]')) {
		return (
			<DeployProvider {...contexts}>
				<PageContext.Provider value={contexts}>{children}</PageContext.Provider>
			</DeployProvider>
		);
	}
	if (router.pathname.includes('/projects/[projectId]')) {
		return (
			<ProjectProvider {...contexts}>
				<PageContext.Provider value={contexts}>{children}</PageContext.Provider>
			</ProjectProvider>
		);
	}
	if (router.pathname.includes('/templates/[templateId]')) {
		return (
			<TemplateProvider {...contexts}>
				<PageContext.Provider value={contexts}>{children}</PageContext.Provider>
			</TemplateProvider>
		);
	}
	if (router.pathname.includes('/[workspaceId]')) {
		return (
			<WorkspaceProfileProvider {...contexts}>
				<PageContext.Provider value={contexts}>{children}</PageContext.Provider>
			</WorkspaceProfileProvider>
		);
	}
	return <PageContext.Provider value={contexts}>{children}</PageContext.Provider>;
};

export { PageProvider };
